import { t } from '../../i18n';
// client/admin-client/src/components/notice/NoticeList.jsx
import React from 'react';
function Badge({ children }) {
    return (<span className="text-xs px-2 py-0.5 rounded bg-gray-100 text-gray-700 border border-gray-200">
      {children}
    </span>);
}
function formatDate(iso) {
    if (!iso)
        return '-';
    try {
        const d = new Date(iso);
        const pad = (n) => String(n).padStart(2, '0');
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    }
    catch {
        return '-';
    }
}
function NoticeCard({ item, active, onClick, onEdit }) {
    return (<button onClick={onClick} className={[
            'w-full text-left p-3 rounded-lg border shadow-sm',
            active ? 'border-gray-900 bg-white' : 'border-gray-200 bg-white hover:border-gray-400',
        ].join(' ')}>
      <div className="flex items-start justify-between gap-2">
        <div className="font-semibold leading-snug line-clamp-2">
          {item.isPinned ? '📌 ' : ''}
          {item.title || t("(\uC81C\uBAA9 \uC5C6\uC74C)")}
        </div>
        <button onClick={(e) => {
            e.stopPropagation();
            onEdit(item);
        }} className="text-xs px-2 py-1 rounded border border-gray-200 hover:border-gray-400" title={t("\uC218\uC815")}>{t("\uC218\uC815")}</button>
      </div>

      <div className="mt-2 flex flex-wrap gap-2 items-center">
        <Badge>{item.language || 'EN'}</Badge>
        <Badge>{item.isPublished ? t("\uAC8C\uC2DC") : t("\uC784\uC2DC\uC800\uC7A5")}</Badge>
        <span className="text-xs text-gray-500">{formatDate(item.updatedAt || item.createdAt)}</span>
      </div>

      <div className="mt-2 text-xs text-gray-500">
        writer: <span className="text-gray-700">{item.writer || '-'}</span>
      </div>
    </button>);
}
export default function NoticeList({ items, selectedId, query, onQueryChange, filter, onFilterChange, onSelect, onQuickCreate, onEdit, }) {
    return (<div className="rounded-xl border border-gray-200 bg-white shadow-sm overflow-hidden">
      <div className="p-3 border-b border-gray-200 bg-gray-50">
        <button onClick={onQuickCreate} className="w-full rounded-lg border border-gray-300 bg-gray-100 hover:bg-gray-200 px-3 py-3 text-left">
          <div className="font-semibold">{t("+ \uACF5\uC9C0 \uC791\uC131")}</div>
          <div className="text-xs text-gray-500 mt-1">{t("(\uC5EC\uAE30 \uD074\uB9AD\uD558\uBA74 \uC0C8 \uACF5\uC9C0 \uBAA8\uB2EC \uC624\uD508)")}</div>
        </button>

        <div className="mt-3 flex flex-col sm:flex-row gap-2">
          <input value={query} onChange={(e) => onQueryChange(e.target.value)} placeholder={t("\uAC80\uC0C9: \uC81C\uBAA9/\uBCF8\uBB38/\uC791\uC131\uC790")} className="flex-1 px-3 py-2 rounded border border-gray-200 focus:outline-none focus:border-gray-500"/>
          <select value={filter} onChange={(e) => onFilterChange(e.target.value)} className="w-full sm:w-auto px-2 py-2 rounded border border-gray-200 bg-white">
            <option value="all">{t("\uC804\uCCB4")}</option>
            <option value="published">{t("\uAC8C\uC2DC")}</option>
            <option value="draft">{t("\uC784\uC2DC")}</option>
          </select>
        </div>
      </div>

      <div className="p-3 space-y-2 max-h-[70vh] overflow-auto">
        {items.length === 0 ? (<div className="text-sm text-gray-500 p-6 text-center">{t("\uACF5\uC9C0\uAC00 \uC5C6\uC5B4. \uC704\uC5D0\uC11C \uC0C8\uB85C \uC791\uC131\uD574\uC918.")}</div>) : (items.map((it) => (<NoticeCard key={it.id} item={it} active={it.id === selectedId} onClick={() => onSelect(it.id)} onEdit={onEdit}/>)))}
      </div>
    </div>);
}
